import { BaseFieldFilter, NativeFieldFilter } from 'module/api/filter/types';
import { Operation } from 'module/api/filter/types';
import { unreachable } from 'module/helpers/unreachable';
import { TextField } from 'module/types/filter-field/field/filterable-field';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'module/types/filter-field/filter/text';

const toApiFormat = (filter: TextFieldFilter): BaseFieldFilter => {
  switch (filter.type) {
    case TextFieldFilterOperationType.IsEmpty:
      return {
        operation: Operation.IsEmpty,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.IsNotEmpty:
      return {
        operation: Operation.IsNotEmpty,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.Contains:
      return {
        operation: Operation.Contains,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.DoesNotContain:
      return {
        operation: Operation.NotContains,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter);
  }
};

const toType = (operation: Operation): TextFieldFilterOperationType => {
  switch (operation) {
    case Operation.IsEmpty:
      return TextFieldFilterOperationType.IsEmpty;
    case Operation.IsNotEmpty:
      return TextFieldFilterOperationType.IsNotEmpty;
    case Operation.Contains:
      return TextFieldFilterOperationType.Contains;
    case Operation.NotContains:
      return TextFieldFilterOperationType.DoesNotContain;
    case Operation.NoneOf:
    case Operation.OneOf:
    case Operation.HasValue:
    case Operation.IsNull:
    default:
      return unreachable(operation as never);
  }
};

const parse = (
  { operation, value }: NativeFieldFilter,
  field: TextField,
): TextFieldFilter => {
  const type = toType(operation);

  switch (type) {
    case TextFieldFilterOperationType.IsEmpty:
    case TextFieldFilterOperationType.IsNotEmpty:
      return { field, type };
    case TextFieldFilterOperationType.Contains:
    case TextFieldFilterOperationType.DoesNotContain: {
      const string = (value ? JSON.parse(`"${value}"`) : null) as string | null;

      return { field, type, value: string == null ? undefined : string };
    }
    default:
      return unreachable(type);
  }
};

export const TextFilter = {
  toApiFormat,
  parse,
};
